import '../styles/Footer.css';


export default function Footer(){
    return (
        <footer className="footer">
  <div className="footer-content">
    <div className="footer-section">
      <h3>Infinipoint Technologies</h3>
      <p>Leading the way in technological innovation</p>
    </div>
    <div className="footer-section">
      <h3>Quick Links</h3>
      <ul>
        <li><a href="/products">Products</a></li>
        <li><a href="/about">About Us</a></li>
        <li><a href="/contact">Contact</a></li>
      </ul>
    </div>
    <div className="footer-section">
      <h3>Contact Info</h3>
      <p>Email: connect@infinipoint.ai</p>
      <p className='bold-text'>Head Office</p>
      <p>Address: #122 Optima, Puttappa Industrial Estate, White Field Road, Mahadevapura</p>
      <p>Bengaluru, Karnataka - 560048</p>
    </div>
    <div className="footer-section">
      <h3>Follow Us</h3>
      <div className="social-icons">
        <a href="https://www.linkedin.com/company/infinipoint-technologies-pvt-ltd/" target="_blank" rel="noopener noreferrer">
          {/* <Linkedin size={24} /> */}
          <i className={`fa-brands fa-linkedin-in fa-2x`}></i>
        </a>
        <a href="https://api.whatsapp.com/send/?phone=919168617657&type=phone_number" target="_blank" rel="noopener noreferrer">
          {/* <Linkedin size={24} /> */}
          {/* <FontAwesomeIcon icon={faLinkedinIn} /> */}
          <i className={`fa-brands fa-whatsapp fa-2x`}></i>
        </a>
        {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
          <Twitter size={24} />
        </a>
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
          <Instagram size={24} />
        </a> */}
      </div>
    </div>
  </div>
  <div className="footer-bottom">
    <p>&copy; 2025 Infinipoint Technologies. All rights reserved.</p>
  </div>
</footer>
    );
}